<script>
import _ from 'lodash'

export default {
  props: {
    resources: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      maxResults: 3,
    }
  },
  computed: {
    shouldShowSearchSuggestion() {
      return !_.isEmpty(this.resources)
    },

    getSuggestedResources() {
      return _.take(this.resources, this.maxResults)
    },
  },
  methods: {
    async goToResource({ resourceId }) {
      await this.$router.push({
        name: 'resource',
        params: { resourceId },
      })
    },
  },
}
</script>

<template>
  <div v-if="shouldShowSearchSuggestion" :class="$style.searchSuggestionContainer">
    <div
      v-for="resource in getSuggestedResources"
      :key="resource.resourceId"
      :class="$style.searchSuggestionItemContainer"
      @click="goToResource(resource)">
      <div :class="$style.searchSuggestionItem">
        <div :class="$style.breadcrumbs">
          <p class="overline-text color-gray">
            Resources
            <template v-if="resource.categoryName">> {{ resource.categoryName }}</template>
            <template v-if="resource.subcategoryName">> {{ resource.subcategoryName }}</template>
          </p>
        </div>
        <p class="p1 color-primary-blue">{{ resource.title }}</p>
      </div>
    </div>
  </div>
</template>

<style lang="scss" module>
@import '@design';

.searchSuggestionContainer {
  z-index: 99;
  overflow: hidden;
  background: $white;
  border: 1px solid $light-gray;
  border-radius: 16px;
}

.searchSuggestionItemContainer {
  padding: 16px;
  cursor: pointer;

  &:hover {
    background: $lightest-gray;
  }
}

.searchSuggestionItem {
  width: 90%;
  border-bottom: 1px solid $lightest-gray;

  &:first-child {
    padding-top: 0;
  }

  &:last-child {
    padding-bottom: 0;
    border-bottom: none;
  }
}

.breadcrumbs {
  margin-bottom: 6px;
}
</style>
